import { SyncOriginalAssetFileSuccess, SyncOriginalAssetFileFailed } from './internal';

export const isSyncAssetFileSuccessResponse = (
  response: SyncOriginalAssetFileSuccess | SyncOriginalAssetFileFailed,
): response is SyncOriginalAssetFileSuccess => response.success && response.success === true;
